import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import Header from '@src/components/Header';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import './styles.scss';

export const PublishedOpeningApplicantsHeader: FC = () => {
  return (
    <div className="published-opening-applicants-header">
      <Header title={'Add opening'}>
        <div className="published-opening-applicants-header__nav">
          <div className="published-opening-applicants-header__nav-item">
            <Svg className="published-opening-applicants-header__icon" src={FrCheckSvg} />
            <span>Opening published! 🎉</span>
          </div>
          <div className="published-opening-applicants-header__nav-item">
            <div className="published-opening-applicants-header__nav-order">6</div>
            <span>Invite candidates</span>
          </div>
        </div>
      </Header>
    </div>
  );
};
